<template>
	<div>
		<headdv :headTitle="headTitle" :isBackShow="true" :goPath="goPatHead" :activeWebTitle = 'activeWebTitle'></headdv>
		<div style="height:80px;"></div>
		<div class="content_dv" :style="{height:(screenHeight-80-28)+'px'}">
			<div class="content_dv_dv">
				<!-- start -->
				<!-- <div class="header flex-row">
					<div></div>
					<div class=" flex-row">
						<div class="add" @click="addManager">添加</div>
					</div>
				</div> -->
				<headdv2 @tapAddFun="addManager" @SearchFun="SearchFun" @allDelFun="allDelFun"  @condition1="condition1" :headData="headData"></headdv2>
				<div class="content">
					<el-table :data="accountList" header-row-class-name="headrow" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column prop="u_id" label="id" width="80"></el-table-column>
						<el-table-column prop="u_avatar" label="头像" width="160">
							<template slot-scope="scope">
								<img :src="scope.row.u_avatar" alt style="width: 40px;height: 40px;border-radius: 50%" />
							</template>
						</el-table-column>
						<el-table-column prop="u_name" label="用户名" width="180"></el-table-column>
						<el-table-column prop="u_nickname" label="昵称" width="180"></el-table-column>
						<el-table-column prop="u_phone" label="手机号" width="160"></el-table-column>
						<el-table-column prop="u_email" label="邮箱" width="160"></el-table-column>
						<el-table-column prop="u_growth_value" label="成长值" width="160"></el-table-column>
						<el-table-column prop="u_sex" label="性别" width="160" :formatter="formatter_u_sex"></el-table-column>
						<el-table-column prop="u_is_vip" label="是否为VIP" width="160" :formatter="formatter_u_isvip"></el-table-column>
						<el-table-column prop="u_is_agent" label="是否为代理商" width="160" :formatter="formatter_u_is_agent"></el-table-column>
						<el-table-column prop="u_status" label="用户状态" width="160" :formatter="formatter_u_status"></el-table-column>
						<el-table-column prop="u_vip_starttime" label="VIP开始时间" width="160" :formatter="formatter_time"></el-table-column>
						<el-table-column prop="u_vip_endtime" label="VIP结束时间" width="160" :formatter="formatter_time"></el-table-column>
						<el-table-column prop="u_spread_code" label="推广码" width="160"></el-table-column>
						<el-table-column prop="u_spread_id" label="推荐人ID" width="160"></el-table-column>
						<el-table-column prop="u_spread_name" label="推荐人名字(伪)" width="160"></el-table-column>
						<el-table-column prop="u_regist_ip" label="注册IP" width="160"></el-table-column>
						<el-table-column prop="u_regist_time" label="注册时间" width="160" :formatter="formatter_time"></el-table-column>
						<el-table-column prop="u_add_time" label="添加时间" width="160" :formatter="formatter_time"></el-table-column>
						<el-table-column prop="u_birthday" label="生日" width="160"></el-table-column>
						<el-table-column prop="u_signature" label="个性签名" width="160"></el-table-column>
						<el-table-column label="操作"  width="160">
						<template slot-scope="scope">
							<el-button	class="edit"	size="small"	type="text"	icon="iconfont icon-zhongxinshuru"	@click="editTangChuan(scope.row)"	>编辑</el-button>
							<el-button size="small"	type="text"	icon="iconfont icon-qingchujiaose"	@click.native.prevent="handleDeleteClick(scope.row)"	>删除</el-button>
						</template>
						</el-table-column>
					</el-table>
				</div>
				
				<!--分页-->
            	<page :pageData="pageData" @changeSizeFun="handleSizeChange" @changeCurrentFun="handleCurrentChange"></page>
			</div>
		</div>
		<!-- 底部 -->
		<footerdv></footerdv>
		<!-- 编辑/添加 -->
		<el-dialog :visible.sync="dialogVisible" width="650px" class="dialog">
			<div class="dialog-title" slot="title">{{isEditOrAdd?'修改':'添加'}}</div>
			<!-- 内容区 start-->
			<el-form ref="staffForm" :rules="rules" :model="staffForm" label-width="100px">
				<el-form-item label="用户名:" prop="u_name">
					<el-input v-model="staffForm.u_name" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="手机号:" prop="u_phone">
					<el-input v-model="staffForm.u_phone" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="密码：" prop="u_password">
					<el-input type="u_password" v-model="staffForm.u_password" placeholder="请输入密码"></el-input>
				</el-form-item>
				<el-form-item label="邮箱:" prop="u_email">
					<el-input v-model="staffForm.u_email" placeholder="请输入邮箱"></el-input>
				</el-form-item>
				<el-form-item label="个性签名:" prop="u_signature">
					<el-input type="textarea" v-model="staffForm.u_signature" placeholder="请输入用户名"></el-input>
				</el-form-item>
				<el-form-item label="是否机器人:" prop="u_reboot">
					<el-switch v-model="staffForm.u_reboot" inactive-text="否" active-text="是" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
				<el-form-item label="性别：" prop="u_sex">
					<el-switch v-model="staffForm.u_sex" inactive-text="否" active-text="是" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="resetForm('staffForm')">取 消</el-button>
				<el-button type="primary" @click="saveForm('staffForm')">保 存</el-button>
			</span>
		</el-dialog>

		<!-- 批量修改 -->
		<el-dialog :visible.sync="statusVisible" width="650px" class="dialog">
			<div class="dialog-title" slot="title">批量修改用户状态</div>
			<!-- 内容区 start-->
			<el-form   label-width="100px">
				<el-form-item label="用户状态：" prop="u_status">
					<el-switch v-model="u_status" inactive-text="否" active-text="是" :inactive-value="0" :active-value="1"></el-switch>
				</el-form-item>
			</el-form>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="statusVisible=false">取 消</el-button>
				<el-button type="primary" @click="updataStatus()">保 存</el-button>
			</span>
		</el-dialog>
		
		<!-- 删除 -->
		<el-dialog :visible.sync="delDate.status" width="400px" class="dialog">
			<div class="dialog-title" slot="title">删除部门/权限</div>
			<!-- 内容区 start-->
			<span>确定删除该部门/权限?</span>
			<!-- 内容区 end -->
			<span slot="footer" class="dialog-footer">
				<el-button @click="delDate.status=false">取 消</el-button>
				<el-button type="primary" @click="allDeleteEvent">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>
<script>
export default {
	data() {
		return {
			headData:{
				title:'后台账号列表',
				add:true,
				search:true,
				del:false,
				condition1:true,
				condition2:false,
				condition3:false,
				condition4:false,
				condition5:false,
			},
			screenHeight: document.documentElement.clientHeight ,// 屏幕高度
			activeWebTitle:'设置',
			//分页
			pageData: {
				pagecount: 1, //总页数  ,默认1
				pagesize: 10, //每页多少条  默认10
				pageindex: 1, //当前页  默认1
				count: 1,
			},
			u_reboot:0, //是否为机器用户 0否 1是
			u_status:0, //用户状态 0:正常 1:禁用
			multipleSelection: [],      //操作多选的数据---   左边勾选的框都会显示在这个数组中
			statusVisible:false,
			delarr: [], //存放删除的数据
			//删除弹窗
			delDate: {
				title: "删除账号",
				label: "删除数据不可恢复，确定删除？",
				status: false,
			},
			//分组id
			problemArrId_type: [],
			accountList: [], //列表数据
			checkedList: [], //选中的绑定值
			headTitle: "员工管理",
			goPatHead: "settings",
			dialogVisible: false,   //开启验证
			isEditOrAdd: false, //判断是添加还是编辑，true为编辑/false为添加
            //修改编辑的数据
			staffForm: {
				u_id:'',
				u_name: "",
				u_phone: "",
				u_password: "",
				u_email: "",
				u_signature: "",
				u_reboot: 0,
				u_sex:0,
				
			},
			//验证规则
			rules: {
				u_name: [{ required: true, message: "请输入用户名", trigger: "blur" },],
				u_phone: [{ required: true, message: "请输入手机号码", trigger: "blur" }],
				u_password: [{ required: true, message: "请输入密码", trigger: "blur" }],
				u_reboot: [{ required: true, message: "请选择是否机器人", trigger: "blur" }],
			},
		};
	},
	created() {
		this.getclasslist_arrid();
		this.getclasslist();
	},
	methods: {
		//批量修改状态  保存
		updataStatus(){
			let ids = ''
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				if(ids == ''){
					ids = this.multipleSelection[i].u_id
				}else{
					ids = ids + ',' + this.multipleSelection[i].u_id
				}
			}
			let fromData = {
				u_id:ids,
				u_status:this.u_status,
			}
			this.https(this.apiList.batchUpdateUser, fromData).then(
				(response) => {
				if (response.data.code == this.common.code){
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "批量修改");
				}
				this.statusVisible = false; //隐藏提示框
				}
			);
		},
		//格式化内容--时间
		formatter_time(row, column, cellValue, index) {
		let time = this.gettime.format(cellValue*1000,3) 
		return time;
		},
		//格式化内容--性别
		formatter_u_sex(row, column, cellValue, index) {
			if (cellValue == 1) {
					return "男";
			} else {
					return "女";
			}
		},
		//格式化内容--部门		
		formatter_ar_id(row, column, cellValue, index) {
			for (let i = 0; i < this.problemArrId_type.length; i++) {
				if (cellValue == this.problemArrId_type[i].ar_id) {
					return this.problemArrId_type[i].ar_name;
				}
			}
		},

		
		//返回
		goBack() {
			this.$router.go(-1);
		},
		//获取列表数据--部门列表
		getclasslist_arrid() {
			this.is_ok = false; //控制帅选请求 一个一个来
			let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}`;
			this.https(this.apiList.getRoleList + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
				this.problemArrId_type = response.data.data.rows; //列表数据
				}
			});
		},
		//获取列表数据--用户列表
		getclasslist() {
			this.is_ok = false; //控制帅选请求 一个一个来
			let get = `?limit=${this.pageData.pagesize}&page=${this.pageData.pageindex}&u_reboot=${this.u_reboot}`;
			this.https(this.apiList.getUserList + `${get}`).then((response) => {
				if (response.data.code == this.common.code) {
               this.accountList = response.data.data.rows; //列表数据
					this.pageData.pagecount = response.data.data.total_page; //总页数
					this.pageData.count = response.data.data.total; //总条数
				}
			});
		},
		// 点击添加按钮
		addManager() {
			this.dialogVisible = true;
			this.isEditOrAdd = false;
		},
		//添加--的确定
		createAccount() {
			let fromData = {}
			for(let key in this.staffForm){
				if(key !='id'){
					fromData[key] = this.staffForm[key]
				}
			}	
			this.https(this.apiList.addUser, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					for(let key in this.staffForm){
						if(key == 'u_reboot' || key == 'u_reboot') {
							this.staffForm[key] = 0
						}else {
							this.staffForm[key] = ''
						}
					}
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "添加");
				}
				this.dialogVisible = false; //隐藏提示框
				}
			);
		},
		
		//点击编辑事件   显示修改弹窗
		editTangChuan(row) {
			this.dialogVisible = true;
			this.isEditOrAdd = true;
			for(let key in this.staffForm){
				this.staffForm[key] = row[key]
			}	
		},
		//编辑弹窗   确定按钮
		createAccount_bianji() {
			console.log(2222)
			let fromData = {}
			for(let key in this.staffForm){
				fromData[key] = this.staffForm[key]
			}	
			this.https(this.apiList.updateUser,fromData).then((response) => {
				if (response.data.code == this.common.code) {
					this.getclasslist();
					//弹窗提示
					this.tc_element(	response.data.msg,	response.data.code,	2,	"编辑");
				}
				this.dialogVisible = false;
			});
		},
		//点击删除按钮  的点击事件
		handleDeleteClick(row) {
			this.delDate.status = true;
			const id = row.au_id;
			this.delarr.push(id);
		},
		//点击批量删除按钮  的点击事件
		AllDeleteClick(row) {
			this.delDate.status = true;
			const length = this.multipleSelection.length;
			for (let i = 0; i < length; i++) {
				this.delarr.push(this.multipleSelection[i].id);
			}
		},
		//点击删除弹窗的确定按钮
		allDeleteEvent() {
			let fromData = {
				au_id : this.delarr[0],
			}
			this.https(this.apiList.deleteAdminUser, fromData).then(
				(response) => {
				if (response.data.code == this.common.code) {
					if (this.accountList.length <= 1) {
					if (this.pageData.pageindex == 1) {
						this.pageData.pageindex = 1;
					} else {
						this.pageData.pageindex--;
					}
					}
					this.getclasslist();
					//弹窗提示
					this.tc_element(response.data.msg, response.data.code, 2, "删除数据");
				}
				this.delDate.status = false; //隐藏提示框
				this.delarr = [];
				}
			);
		},
		// 保存
		saveForm(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					// 校验通过
					//手机验证
					var phonereg = /^[1][3,4,5,7,8][0-9]{9}$/;
					if (!phonereg.test(this.staffForm.u_phone)) {
						this.$message.error('请输入正确的手机号码');
						return false;
					}
					//手机验证
					var emailreg = /^([a-zA-Z\d])(\w|\-)+@[a-zA-Z\d]+\.[a-zA-Z]{2,4}$/
					if (!emailreg.test(this.staffForm.u_email)) {
						this.$message.error('请输入正确的邮箱');
						return false;
					}
					this.dialogVisible = false;
					if (this.isEditOrAdd) {
						//  编辑
						this.createAccount_bianji()
					} else {
						//  添加
						this.createAccount()
					}
				} else {
					//验证失败
					console.log("error submit!!");
					return false;
				}
			});
		},
		//编辑/添加--取消
		resetForm(formName) {
			this.$refs[formName].resetFields();
			this.dialogVisible = false;
		},
		//删除-取消
		deleteRow() {
			this.delDate.status = false;
		},
		

		//头部组件促发的方法
        //添加
        tapAddFun(){
            this.isShowAddForm = true
        },
        //搜索方法
        SearchFun(data){
            console.log(data)
        },
        //批量删除
        allDelFun(){
           console.log('del')
        },
        //条件筛选1
        condition1(){
			  this.statusVisible = true
            console.log('批量修改')
        },
        //条件筛选2
        condition2(){
            console.log('condition2')
        },
        //条件筛选3
        condition3(){
            console.log('condition3')
        },
        //条件筛选4
        condition4(){
            console.log('condition4')
        },
        //条件筛选5
        condition5(){
            console.log('condition5')
        },
        //分页
			//pageSize 改变时会触发    每页条数
			handleSizeChange(val) {
				console.log(val)
				this.pageData.pagesize = val 
				this.getclasslist();
			},
			//currentPage 改变时会触发     当前页
			handleCurrentChange(val) {
				console.log(val)
				this.pageData.pageindex = val
				this.getclasslist();
			},
        //取消删除--子组件促发
        cancelDel(){
            this.delDate.status = false;
        },
        //确定删除--子组件促发
        determineDel(){
            //this.allDeleteEvent()
		  },
			//操作多选  --获取多选的内容
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
		  
			//格式化内容--是否会员
			formatter_u_isvip(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "是";
					} else {
						return "否";
					}
			},
			//格式化内容--是否为代理商
			formatter_u_is_agent(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "是";
					} else {
						return "否";
					}
			},
			//格式化内容--是否会员
			formatter_u_status(row, column, cellValue, index) {
					if (cellValue == 1) {
						return "正常";
					} else {
						return "禁用";
					}
			},
	},
};
</script>
<style lang="scss" scoped>
// .header {
//   width: 100%;
//   height: 60px;
//   border-bottom: 1px solid #f2f2f2;
//   justify-content: space-between;
//   ::v-deep .el-page-header__left {
//     color: #aaaaaa;
//   }
//   ::v-deep .el-page-header__left::after {
//     background-color: transparent;
//   }
//   .title {
//     font-size: 18px;
//     color: #4f7da4;
//   }
//   .add {
//     width: 60px;
//     height: 36px;
//     line-height: 36px;
//     text-align: center;
//     border-radius: 6px;
//     color: #ffffff;
//     background: #4f7da4;
//     cursor: pointer;
//   }
// }
// 表格样式
::v-deep .el-table {
  .headrow,
  .headrow th {
    background-color: #f1f4f5 !important;
  }
  th > .cell {
    color: #555555;
  }
  .cell {
    color: #aaaaaa;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
  }
  .el-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #ec808d;
    &.edit {
      color: #4f7da4;
    }
    .iconfont {
      font-size: 14px;
      margin-right: 5px;
    }
  }
}
// 对话框
.dialog {
  .dialog-title {
    width: 100%;
    height: 40px;
    background: #4f7da4;
    line-height: 40px;
    color: #ffffff;
    padding-left: 18px;
    font-size: 14px;
    box-sizing: border-box;
  }
  // 对话框头部
  ::v-deep .el-dialog__header {
    padding: 0;
  }

  ::v-deep .el-dialog__headerbtn {
    top: 7px;
    right: 10px;
    font-size: 24px;
    .el-dialog__close {
      color: #ffffff;
    }
  }
  ::v-deep .el-dialog__body {
    padding: 30px !important;
  }
  // 底部按钮
  ::v-deep .el-dialog__footer {
    text-align: center;
  }
  ::v-deep .el-button {
    width: 128px;
    &.el-button--default {
      background: #f2f2f2;
      color: #aaaaaa;
      border: none;
    }
    &.el-button--primary {
      background: #4f7da4;
      border: none;
    }
    & + .el-button {
      margin-left: 25px;
    }
  }
}
</style>